import { render } from "./booking3.vue?vue&type=template&id=5023b5b2"
import script from "./booking3.vue?vue&type=script&lang=js"
export * from "./booking3.vue?vue&type=script&lang=js"
script.render = render

export default script